import { render, staticRenderFns } from "./GameActions.vue?vue&type=template&id=f4149e8c&"
import script from "./GameActions.vue?vue&type=script&lang=js&"
export * from "./GameActions.vue?vue&type=script&lang=js&"
import style0 from "./GameActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports